module.exports = __webpack_public_path__ + "img/two.5b412203.png";